// Mint-Mov-Phone3 khung 3 "Dẫn đường & chứng từ": dữ liệu mẫu + logic thuần (giữ trong bộ nhớ, không ghi DB).
export const TRIP = { code: 'TRF2610078', job: 'SE260619200', dest: 'Cat Lai Giang Nam' } as const;

export type Photo = readonly [label: string, phase: string];
export const PHOTOS0: readonly Photo[] = [
  ['Lấy rỗng 1', 'PickupEmpty'], ['Lấy rỗng 2', 'PickupEmpty'], ['Lấy rỗng 3', 'PickupEmpty'], ['Chứng từ', 'Documents'],
  ['Rời kho 1', 'LeaveWarehouse'], ['Rời kho 2', 'LeaveWarehouse'], ['Máy lạnh', 'LeaveWarehouse'], ['EIR rỗng', 'Documents'],
];
export type Memo = readonly [who: string, text: string, at: string];
export const MEMOS0: readonly Memo[] = [
  ['Điều độ', 'Hạ trước 14:00, cổng B ca chiều', '06:05'],
  ['Kho SKVietNam', 'Gọi phòng XNK trước khi vào 30 phút', '22/10'],
];
export const CONTACTS = [
  { k: 'Kho SKVietNam · Phòng XNK', v: 'Liên hệ kho trên lệnh', who: 'Kho SKVietNam' },
  { k: 'Điều xe đang trực · PhongNT', v: 'Trưởng Vận tải', who: 'PhongNT' },
  { k: 'CS phụ trách · ThuyNTT', v: 'Job SE260619200', who: 'ThuyNTT' },
] as const;
export const DOCS = [
  { k: 'Booking CMA SGN3473689', v: 'PDF · đã nhận 05:01', msg: 'Đã tải Booking' },
  { k: 'Lệnh cấp rỗng', v: 'CMA-ER-261023-114', msg: 'Đã tải lệnh cấp rỗng' },
  { k: 'Lệnh vận chuyển TRF2610078', v: 'PDF in sẵn', msg: 'Đã tải lệnh vận chuyển' },
] as const;
export const PHASES = ['Lấy rỗng', 'Chứng từ', 'Rời kho', 'Hạ cảng'] as const;
export const GVT_DOC =
  'GIẤY VẬN TẢI\nĐơn vị: CÔNG TY TNHH HANA LOGISTICS\nBiển số: 50E13970 · mooc 50RM07187\nHàng: container 40RH OTPU6341068 (hàng lạnh)\nTừ: ICD PHUOC LONG 3 → Kho SKVietNam → Cat Lai Giang Nam\nNgày: 23/10/2026 · lệnh TRF2610078\n[Mộc công ty] · [Chữ ký điều độ PhongNT]';

export interface NavInfo { note: string; turn: string; dist: string; arrow: string; route: string }
export const navInfo = (off: boolean): NavInfo => off
  ? { note: 'lệch tuyến', turn: 'Bạn đã đi khỏi tuyến · quay lại QL51', dist: 'Đang tính lại tuyến', arrow: '↺', route: 'M178 182 C 150 150, 120 120, 60 110' }
  : { note: 'còn 9,4 km · 14:05', turn: 'Rẽ phải vào Nguyễn Thị Định', dist: '350 m', arrow: '↱', route: 'M178 182 C 190 140, 220 100, 260 0' };

export const selCount = (sel: Readonly<Record<number, boolean>>) => Object.values(sel).filter(Boolean).length;
export const photoNote = (total: number, sel: number) => (sel ? `đã chọn ${sel}` : `${total} ảnh`);
export const removeSelected = (photos: readonly Photo[], sel: Readonly<Record<number, boolean>>) => photos.filter((_, i) => !sel[i]);
